import * as React from 'react';
import { CHART_INK, resolveSeriesColors, type ChartSeries } from './chart-utils';

/** Swatch + label per series. Renders nothing for a single series (the title names it). */
export function ChartLegend({ series, className }: { series: ChartSeries[]; className?: string }) {
  if (series.length < 2) return null;
  const colors = resolveSeriesColors(series);
  return (
    <ul
      data-testid="chart-legend"
      className={['flex flex-wrap items-center gap-x-4 gap-y-1', className].filter(Boolean).join(' ')}
      style={{ fontSize: 12, color: CHART_INK.secondary }}
    >
      {series.map((s, i) => (
        <li key={s.key} className="flex items-center gap-1.5">
          <span
            aria-hidden="true"
            className="inline-block h-2.5 w-2.5 rounded-sm"
            style={{ backgroundColor: colors[i] }}
          />
          <span>{s.label}</span>
        </li>
      ))}
    </ul>
  );
}
